module.exports = __webpack_public_path__ + "static/img/支持和服务@2x (1).2ff64e97.png";